import { lang, remCss } from 'src/helpers';
import { MCButton, ToggleSwitch } from 'components/basic';
import LANG_CONST from 'src/helpers/lang/const';
import React from 'react';
import { BASE_ICONS } from 'components/svg';
import moment from 'moment';

export const EditDay = ({ hide, saveTimes, day }) => {
  const [data, setData] = React.useState(day.times);

  return (
    <div
      className='mc-popup-contain'
      style={{
        width: '100%',
        height: '100%',
        maxWidth: '100%',
        maxHeight: '100%',
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        padding: 0
      }}
    >
      <div className='mc-modal-header mc-flex'>
        <MCButton
          width={40}
          iconname={BASE_ICONS.BACK_ARROW}
          primary
          style={{ marginVertical: remCss(-10) }}
          onClick={() => {
            saveTimes(data);
            hide();
          }}
        />
        <div className='mc-popup-title'>{lang.t(LANG_CONST.text.setup_time_slot)}</div>
      </div>
      <div className='mc-modal-body mc-grow'>
        <h1
          style={{
            fontSize: '1.5rem',
            fontWeight: 'bold',
            textAlign: 'center'
          }}
        >
          {day.label}
        </h1>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>Enable/Disable intervals</div>
        {data.map((time, timeIndex) => {
          return (
            <React.Fragment key={timeIndex}>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                  marginBottom: '1rem'
                }}
              >
                <div style={{ minWidth: '60%', textAlign: 'center', fontWeight: 'bold' }}>
                  <span>{moment(time.startTime).format('HH:mm')} </span>
                  <span> to </span>
                  <span> {moment(time.endTime).format('HH:mm')}</span>
                </div>
                <div>
                  {time.slots.map((slot, slotIndex) => {
                    return (
                      <React.Fragment key={slotIndex}>
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            width: '100%'
                          }}
                        >
                          <div>{moment(slot.start).format('HH:mm')}</div>
                          <div style={{ margin: remCss(20) }}> -</div>
                          <div>{moment(slot.end).format('HH:mm')}</div>
                          <div style={{ margin: remCss(20) }}>
                            <ToggleSwitch
                              checked={slot.enabled}
                              onChange={() => {
                                setData((o) =>
                                  o.map((t, ti) => {
                                    if (timeIndex === ti) {
                                      return {
                                        ...t,
                                        slots: t.slots.map((s, si) =>
                                          slotIndex === si ? { ...s, enabled: !s.enabled } : s
                                        )
                                      };
                                    }

                                    return t;
                                  })
                                );
                              }}
                            />
                          </div>
                        </div>
                      </React.Fragment>
                    );
                  })}
                </div>
              </div>
            </React.Fragment>
          );
        })}
      </div>
      <div className='mc-modal-footer' style={{ gap: remCss(20) }}>
        <div className={'mc-grow'} />
        <MCButton
          medium
          dark
          radius
          primary
          style={{ width: remCss(100) }}
          label={LANG_CONST.buttons.save}
          onClick={() => {
            saveTimes(data);
            hide();
          }}
        />
      </div>
    </div>
  );
};
